import type { Image, TextMediaBlock, Video } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";

import type { ResolvedImage } from "./imageResolver";
import imageResolver from "./imageResolver";
import richTextResolver, { ResolvedRichText } from "./richTextResolver";
import type { ResolvedVideo } from "./videoResolver";
import videoResolver from "./videoResolver";

export interface ResovledTextMediaBlock {
    title: ResolvedRichText;
    content: ResolvedRichText;
    media?: ResolvedImage | ResolvedVideo;
    isSmall: boolean;
    reversedOrder: boolean;
    codename: string;
    type: ContentTypeCodenames.TextMediaBlock;
}

const mediaResovler = (data: Image | Video): ResolvedImage | ResolvedVideo | undefined => {
    switch (data?.system?.type) {
        case ContentTypeCodenames.Image:
            return imageResolver(data as Image);
        case ContentTypeCodenames.Video:
            return videoResolver(data as Video);
        default:
            return;
    }
};

const textMediaBlockResovler = (data: TextMediaBlock): ResovledTextMediaBlock => {
    return {
        title: richTextResolver({
            html: data.elements.title.value,
            linkedItems: data.elements.title.linkedItems,
        }),
        content: richTextResolver({
            html: data.elements.copy.value,
            linkedItems: data.elements.copy.linkedItems,
        }),
        isSmall: !!data.elements.isSmall.value[0],
        reversedOrder: data.elements.mediaPosition.value[0].codename === "media",
        media: mediaResovler(data.elements.media.linkedItems[0]),
        codename: data.system.codename,
        type: ContentTypeCodenames.TextMediaBlock,
    };
};

export default textMediaBlockResovler;
